import React, { useEffect, useState } from "react";

import {
  Breadcrumb,
  Button,
  Input,
  message,
  PageHeader,
  Select,
  Form,
  Row,
  Col,
  Popconfirm,
  Checkbox,
  Drawer,
  Table,
  InputNumber,
  Space,
  Spin,
} from "antd";

import { Link } from "react-router-dom";
import Page from "_components/Page";
import TabMenu from "./TabMenu";
import { materialTypeService } from "_services";

function TiepReciptTransactions({ match, history }) {
  const { id } = match.params;
  const { path } = match;

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    setLoading(true);
    materialTypeService
      .getTransactions(id)
      .then((x) => {
        setItems(x.content);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setError(error);
      });
  }, []);

  const getLineColumns = () => {
    let columns = [];
    columns.push({
      title: "Code",
      dataIndex: "item.code",
      key: "Code",
      width: "10%",
      render: (text, record) => {
        if (record) {
          return `${record?.item?.code}`;
        }
      },
    });

    columns.push({
      title: "Item Name",
      dataIndex: "item.name",
      key: "itemname",
      width: "20%",
      render: (text, record) => {
        if (record) {
          return `${record?.item?.name}`;
        }
      },
    });
    columns.push({
      title: "Username",
      dataIndex: "employee.username",
      key: "Username",
      width: "20%",
      render: (text, record) => {
        if (record) {
          return `${record?.employee?.username}`;
        }
      },
    });

    return columns;
  };

  return (
    <PageHeader
      title={
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/dashboard">Dashboard</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/stock-receipts">Stock Receipts Search</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`${path}`}> Transactions </Link>
          </Breadcrumb.Item>
        </Breadcrumb>
      }
      //Add buttons in the page header
      // extra={getActionButtons()}
    >
      <Page inner>
        <Spin tip="Loading..." spinning={loading}>
          <TabMenu menu="transactions" id={id} />

          {items && (
            <Table
              bordered
              pagination={false}
              columns={getLineColumns()}
              dataSource={items}
              size="small"
            />
          )}
        </Spin>
      </Page>
    </PageHeader>
  );
}

export default TiepReciptTransactions;
